(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vv-card-colors"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vv-card-colors'))customElements.define('vv-card-colors',class extends HTMLElement{
 connectedCallback(){
  this.replaceChildren();let variants=[];try{variants=JSON.parse(this.dataset.variants);}catch{}
  const colors={'green/wood':'linear-gradient(90deg,#76a95a 50%,#94704f 50%)','silver/wood':'linear-gradient(90deg,#b4bbc4 50%,#94704f 50%)','sandal/wood':'linear-gradient(90deg,#c7aa77 50%,#94704f 50%)',pink:'#d58b99',red:'#d32924',orange:'#ed852c',brown:'#6b3f2a',green:'#76a95a',white:'#fff',black:'#202020',blue:'#3277ba',beige:'#d7c3a2',sandal:'#c7aa77',bronze:'#987044','dark brown':'#473025','dark chocolate brown':'#392b25',yellow:'#ebcf38'};
  const seen=new Set();for(const variant of variants){const key=variant.color.toLowerCase().trim();if(seen.has(key)||!variant.image||!colors[key])continue;seen.add(key);
   const button=document.createElement('button');button.type='button';button.title=variant.color;button.dataset.variantId=variant.id;button.setAttribute('aria-label',this.dataset.title+' — '+variant.color);button.setAttribute('aria-pressed',String(variant.id===this.dataset.defaultVariant));if(colors[key].startsWith('linear-gradient'))button.style.background=colors[key];else button.style.backgroundColor=colors[key];button.addEventListener('click',event=>{
    event.preventDefault();event.stopPropagation();
    const card=this.closest('product-card');if(!card)return;
    const gallery=card.querySelector('.card-gallery');if(!gallery)return;
    let image=gallery.querySelector('.vv-filter-variant-image');
    if(!image){image=document.createElement('img');image.className='vv-filter-variant-image';image.decoding='async';(gallery.querySelector('[ref="cardGalleryLink"]')||gallery).append(image);}
    image.src=variant.image;image.alt=this.dataset.title+' — '+variant.color;image.hidden=false;gallery.classList.add('vv-filter-image-active');
    card.querySelectorAll('a[href*="/products/"]').forEach(link=>{const url=new URL(link.getAttribute('href'),window.location.origin);url.searchParams.set('variant',variant.id);link.href=url.pathname+url.search+url.hash;});
    card.dataset.featuredMediaUrl=variant.image;
    this.querySelectorAll('button').forEach(other=>other.setAttribute('aria-pressed',String(other===button)));
    this.dispatchEvent(new CustomEvent('vv:card-color',{bubbles:true,detail:{variant}}));
   });this.append(button);
  }
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vv-inline-search"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('vv-inline-search')){
customElements.define('vv-inline-search',class extends HTMLElement{
 connectedCallback(){
  this.listeners=new AbortController();const signal=this.listeners.signal;
  this.details=this.querySelector('details');this.input=this.querySelector('input');this.list=this.querySelector('ul');this.status=this.querySelector('[role="status"]');
  this.details.addEventListener('toggle',()=>{if(this.details.open)this.input.focus();else this.cancel();},{signal});
  this.input.addEventListener('input',()=>{clearTimeout(this.timer);this.cancel();this.timer=setTimeout(()=>this.search(),180);},{signal});
  this.addEventListener('keydown',e=>{if(e.key==='Escape'){this.details.open=false;this.querySelector('summary').focus();}},{signal});
  document.addEventListener('pointerdown',e=>{if(!this.contains(e.target))this.details.open=false;},{signal});
  this.querySelector('form').addEventListener('submit',e=>{e.preventDefault();clearTimeout(this.timer);this.search();},{signal});
 }
 disconnectedCallback(){clearTimeout(this.timer);this.cancel();this.listeners?.abort();}
 cancel(){this.request?.abort();}
 async search(){
  const query=this.input.value.trim();this.cancel();this.list.replaceChildren();this.status.textContent='';if(!query)return;
  const request=new AbortController();this.request=request;const url=new URL(this.dataset.searchUrl+'.json',location.origin);url.searchParams.set('q',query);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','8');
  try{const response=await fetch(url,{signal:request.signal});if(!response.ok)throw Error();const data=await response.json();if(this.input.value.trim()!==query)return;
   const products=data.resources?.results?.products||[];this.status.textContent=products.length?'':this.dataset.empty;
   for(const product of products){const item=document.createElement('li'),link=document.createElement('a'),label=document.createElement('span');link.href=product.url;label.textContent=product.title;const src=product.featured_image?.url||product.image;if(src){const image=document.createElement('img');image.src=src;image.alt='';image.width=54;image.height=54;link.append(image);}link.append(label);item.append(link);this.list.append(item);}
  }catch(error){if(error.name!=='AbortError')this.status.textContent=this.dataset.error;}
 }
});}
  } catch(e) { console.error(e); }
})();

})();
